import { Coordinates } from '@base/features/game/model/types';
import { ICheckerView, IGameLine, Animation } from './interfaces';

export default class AnimationImpl implements Animation {
  /**
   * конструктор Animation
   * @param {ICheckerView} checker - view шашки
   * @param origin - координаты начала анимации
   * @param destination - координаты конца анимации
   * @param {double} speed - скорость
   * @param {double} lastUpdateTime - время последнего рендера анимации, следует передвать текущее
   * @param {IGameLine} toLine - контейнер в который карта идет
   * @param {function} onAnimationEnd - callback окончания анимации
   */

  duration: number;
  startTime: number;
  endTime: number;

  constructor(
    private checker: ICheckerView,
    private origin: Coordinates,
    private destination: Coordinates,
    private speed: number,
    private lastUpdateTime: number,
    private toLine: IGameLine,
    private onAnimationEnd: Function
  ) {
    var direction = {
      x: destination.x - origin.x,
      y: destination.y - origin.y,
    };
    var targetLength = this.getLength(direction);

    this.duration = Math.max(380, targetLength / speed);
    this.startTime = new Date().getTime();
    this.endTime = this.startTime + this.duration;
    this.checker = checker;

    if (!this.duration) {
      throw new Error(
        'Invalid animation duration,' +
          ' length = ' +
          targetLength +
          ' source = ' +
          JSON.stringify(origin) +
          ' destination = ' +
          JSON.stringify(destination)
      );
    }
  }
  getCurrentPosition(currentTime: number) {
    var x;
    var y;
    var t = (currentTime - this.startTime) / this.duration;
    if (t < 0.0) {
      t = 0.0;
    }
    if (t >= 1.0) {
      x = this.destination.x;
      y = this.destination.y;

      this.onAnimationEnd(this.checker, this.toLine);
    } else {
      x = this.origin.x + (this.destination.x - this.origin.x) * t;
      y = this.origin.y + (this.destination.y - this.origin.y) * t;
    }

    return { x: x, y: y };
  }

  isRunning(currentTime: number) {
    return currentTime < this.endTime;
  }

  getLength(vector: Coordinates) {
    return Math.sqrt(vector.x * vector.x + vector.y * vector.y);
  }

  getDestinationLine() {
    return this.toLine;
  }
}
